// extracted by mini-css-extract-plugin
export default {"sectionNav":"styles_sectionNav__LQ33s","fullWidth":"styles_fullWidth__dRMhB","backdrop":"styles_backdrop__3GIE2","mobile":"styles_mobile__6xVb4"};